import { PROJECT_CODE } from "../../constants";
export const NO_USER_INFO_PATH_NAME = {
  Shenzhen: "sz",
  XuepingxianDraw: "xuepingxian-draw",
  Meizhou: "meizhou",
};

export const MAP_PATH_NAME_TO_PROJECT_CODE = new Map([
  [NO_USER_INFO_PATH_NAME.Shenzhen, PROJECT_CODE.Shenzhen],
  [NO_USER_INFO_PATH_NAME.XuepingxianDraw, PROJECT_CODE.Xiaoyaoxiang],
  [NO_USER_INFO_PATH_NAME.Meizhou, PROJECT_CODE.Meizhou]
]);

export const MAP_PATH_NAME_TO_IMAGE_LIST = new Map([
  [
    NO_USER_INFO_PATH_NAME.Shenzhen,
    ["https://pub-img.treewisdomhealth.com/sz_bg.png"],
  ],
  [
    NO_USER_INFO_PATH_NAME.XuepingxianDraw,
    [
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-01.png",
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-02.png",
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-03.png",
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-04.png",
      "https://pub-img.treewisdomhealth.com/xuepingxian-h5-0827-05.png",
    ],
  ],
  [
    NO_USER_INFO_PATH_NAME.Meizhou,
    [
      "https://pub.img.treewisdomhealth.com/meizhou-h5-01.png",
      "https://pub.img.treewisdomhealth.com/meizhou-h5-02.png",
      "https://pub.img.treewisdomhealth.com/meizhou-h5-03.png",
      "https://pub.img.treewisdomhealth.com/meizhou-h5-04.png",
    ],
  ],
]);
